// extracted by mini-css-extract-plugin
export default {"cls1":"WinBackPing-cls1___d356d98d5830087ab21","cls2":"WinBackPing-cls2___377982713ea3193e3b5 WinBackPing-cls1___d356d98d5830087ab21"};